import React, { useState, useRef } from "react";
import { Col, Row, Input, Form } from "antd";
import { useSelector } from "react-redux";
import ComponentTitle from "./components/ComponentTitle";
import { convertToRGBAString } from "utils/helperFunctions";
import { fontSize } from "utils/CONSTANTS";

const CommentModel = ({ data }) => {
  const [count, setCount] = useState(0);
  const selectedLanguage = useSelector((state) => state.selectedLanguage);
  const errorMessages = useSelector(
    (state) => state.widgetJSON.data.general_settings.error_messages
  );
  const textAreaRef = useRef(null);
  const onChange = (e) => {
    console.log();
    setCount(e.target.value.length);
  };
  return (
    <>
      <ComponentTitle component={data} />
      {/* <Row
        justify="center"
        style={{ paddingLeft: "20px", paddingRight: "20px" }}
      >
        <Col
          className="font-helvetica-neue-medium"
          style={{
            fontSize: fontSize[data.attrs.label_text_size],
            color: convertToRGBAString(data.attrs.label_text_color),
            backgroundColor: convertToRGBAString(data.attrs.label_bg_color),
            padding: 10,
            borderRadius: 8,
            textAlign: "center",
            marginBottom: 10,
          }}
        >
          {data.attrs.label[selectedLanguage]}
        </Col>
      </Row> */}
      <Row
        // style={{ paddingLeft: "20px", paddingRight: "20px" }}
        className="padding"
      >
        <Col
          xs={24}
          className="font-helvetica-neue-medium"
          style={{
            fontSize: fontSize[data.attrs.label_text_size],
            color: convertToRGBAString(data.attrs.label_text_color),
            backgroundColor: convertToRGBAString(data.attrs.label_bg_color),
            border: "1px solid #e3e5e5",
            borderRadius: "8px 8px 0 0",
            borderBottom: "none",
            // borderRadius: 8,
            // textAlign: "center",
            // marginBottom: 10,
            // width: 100,
          }}
        >
          <div className="component-title">
            {data.attrs.label[selectedLanguage]}
          </div>
        </Col>
        <Col xs={24}>
          <Form.Item
            name={data.attrs.name}
            labelCol={{ span: 24 }}
            rules={[
              {
                required: data.attrs.required || false,
                message: errorMessages.required[selectedLanguage],
              },
              {
                min: data.attrs.min_length,
                max: data.attrs.max_length,
                message:
                  count < data.attrs.min_length
                    ? errorMessages.too_short[selectedLanguage]
                    : count > data.attrs.max_length &&
                      errorMessages.too_long[selectedLanguage],
              },
            ]}
          >
            <Input.TextArea
              ref={textAreaRef}
              onChange={onChange}
              style={{
                resize: "none",
                backgroundColor: convertToRGBAString(
                  data?.attrs?.textarea_bg_color
                ),
                fontSize: "16px",
                borderRadius: "0 0 8px 8px",
                color: convertToRGBAString(data?.attrs?.text_color),
              }}
              rows={6}
              className="left-to-right-holder"
              maxLength={data.attrs.max_length}
              placeholder={data.attrs.placeholder[selectedLanguage]}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default CommentModel;
